module.exports = __webpack_public_path__ + "img/email_black_24dp.1b791f54.svg";